import EnvironmentStatus from '../../../../../models/EnvironmentStatus';

// Seconds a cold start is expected to take. SOCI lazy loading landed 2026-10: ~35 s median time-to-usable.
export const ColdStartEstimateSeconds = 60;
// Past this, stop promising a duration and point the learner at support.
export const ColdStartTimeoutSeconds = 180;

export const formatElapsed = seconds => {
  const s = Math.floor(seconds);
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};

// The stage IS the label. Saying 'Setting up...' on one line and 'Preparing your
// workspace...' on the next says the same thing twice, and the duplicate is what
// overflowed the button.
const stageLabel = status => {
  if (status === EnvironmentStatus.Pending) return 'Preparing';
  if (status === EnvironmentStatus.Starting) return 'Starting';
  if (status === undefined || status === null || status === EnvironmentStatus.Stopped) {
    return 'Requesting';
  }
  // Already RUNNING: we are opening a workspace that exists, not building one.
  if (status === EnvironmentStatus.Running) return 'Opening';
  return 'Setting up';
};

const overDetail = elapsedSeconds => {
  if (elapsedSeconds > ColdStartTimeoutSeconds) {
    return 'This is taking longer than usual - contact sdo-support@stanford.edu if it does not finish.';
  }
  if (elapsedSeconds > ColdStartEstimateSeconds) {
    return 'Still working - larger course images can take up to three minutes.';
  }
  return '';
};

// warm: true / false / null (unknown). elapsedSeconds: number, or null when the click time is unknown.
const launchProgress = ({ status, warm, elapsedSeconds }) => {
  const hasTimer = typeof elapsedSeconds === 'number';
  const overEstimate = hasTimer && elapsedSeconds > ColdStartEstimateSeconds;
  if (warm === true && hasTimer && !overEstimate) return { label: 'Almost ready', detail: '' };
  const stage = stageLabel(status);
  return {
    label: hasTimer ? `${stage} ${formatElapsed(elapsedSeconds)}` : stage,
    // Only the exceptional message. The ordinary stage is already in the label.
    detail: overDetail(elapsedSeconds),
  };
};

export default launchProgress;
